import React from "react"
import logo from "../../assets/images/logo/rh-small.svg"

const HackawayLogo = props => <img {...props} src={logo} />

export { HackawayLogo }
